import React, { useEffect, useState } from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';
const testimonials = [{
  name: 'Pastor Mario',
  role: 'Pastor',
  image: 'https://cdn.magicpatterns.com/uploads/beZk6xp1wKEtjxuLT1bGFe/hf_20260222_121317_bd1460c4-5838-4a40-9ebb-48f415b40aae.jpg'
}, {
  name: 'Sonia',
  role: 'Maestra Bíblica 🍎',
  image: 'https://cdn.magicpatterns.com/uploads/9TXeyeLY3soDwLa2Dcs1vw/hf_20260222_121728_09528a1e-7ca3-4cfe-95b9-7bdaa5bade33.png'
}, {
  name: 'Lucas',
  role: 'Líder de Jóvenes 🎸',
  image: 'https://cdn.magicpatterns.com/uploads/emDb6c6N5fUL21BmPTTtcr/hf_20260222_122104_aa7db939-821d-4dd3-a7a7-51d9e8d93c7d.jpg'
}, {
  name: 'Laura',
  role: 'Mamá x3 🧸',
  image: 'https://cdn.magicpatterns.com/uploads/exW3P7SYhzDtTJo6o2W1PU/hf_20260222_122116_958cabe0-dd79-4a34-bcfb-d9359722b2f0.jpg'
}];
export function WhatsAppTestimonials() {
  const [current, setCurrent] = useState(0);
  const [animating, setAnimating] = useState(false);
  const [direction, setDirection] = useState<'left' | 'right'>('right');
  useEffect(() => {
    const interval = setInterval(() => {
      goTo((current + 1) % testimonials.length, 'right');
    }, 4000);
    return () => clearInterval(interval);
  }, [current]);
  function goTo(index: number, dir: 'left' | 'right') {
    if (animating) return;
    setDirection(dir);
    setAnimating(true);
    setTimeout(() => {
      setCurrent(index);
      setAnimating(false);
    }, 300);
  }
  function prev() {
    const index = (current - 1 + testimonials.length) % testimonials.length;
    goTo(index, 'left');
  }
  function next() {
    const index = (current + 1) % testimonials.length;
    goTo(index, 'right');
  }
  return <section className="py-12 md:py-16 relative" style={{
    background: '#F6F1E7'
  }} data-id="element-311">
      <div className="gold-divider absolute top-0 inset-x-0" data-id="element-312" />
      <div className="container mx-auto px-4 max-w-3xl relative z-10" data-id="element-313">
        {/* Header */}
        <div className="text-center mb-10" data-id="element-314">
          <span className="inline-block px-3 py-1 rounded-full text-xs font-bold tracking-widest uppercase mb-3" style={{
          background: 'rgba(200,169,106,0.15)',
          border: '1px solid rgba(200,169,106,0.4)',
          color: '#B89555'
        }} data-id="element-315">
            Testimonios Reales
          </span>
          <h2 className="text-2xl md:text-4xl font-serif font-bold mb-3" style={{
          color: '#1C1C1C'
        }} data-id="element-316">
            Lo Que Dicen Quienes Ya Lo Compraron
          </h2>
          <div className="mx-auto w-20 gold-divider" data-id="element-317" />
        </div>

        {/* Carousel */}
        <div className="relative flex flex-col items-center" data-id="element-318">
          {/* Phone frame */}
          <div className="relative w-full max-w-xs mx-auto" style={{
          userSelect: 'none'
        }} data-id="element-319">
            {/* Prev button */}
            <button onClick={prev} className="absolute left-0 top-1/2 -translate-y-1/2 -translate-x-5 z-20 flex items-center justify-center w-10 h-10 rounded-full transition-all duration-200" style={{
            background: '#FBF8F2',
            border: '1px solid rgba(200,169,106,0.4)',
            boxShadow: '0 2px 8px rgba(60,40,10,0.10)',
            color: '#B89555'
          }} aria-label="Anterior" data-id="element-320">
              <ChevronLeft className="w-5 h-5" data-id="element-321" />
            </button>

            {/* Image */}
            <div className="rounded-3xl overflow-hidden" style={{
            boxShadow: '0 16px 56px rgba(60,40,10,0.18), 0 2px 8px rgba(60,40,10,0.08)',
            border: '2px solid rgba(200,169,106,0.3)'
          }} data-id="element-322">
              <img src={testimonials[current].image} alt={`Testimonio de ${testimonials[current].name}`} className="w-full h-auto block" style={{
              opacity: animating ? 0 : 1,
              transition: 'opacity 0.3s ease'
            }} data-id="element-323" />
            </div>

            {/* Next button */}
            <button onClick={next} className="absolute right-0 top-1/2 -translate-y-1/2 translate-x-5 z-20 flex items-center justify-center w-10 h-10 rounded-full transition-all duration-200" style={{
            background: '#FBF8F2',
            border: '1px solid rgba(200,169,106,0.4)',
            boxShadow: '0 2px 8px rgba(60,40,10,0.10)',
            color: '#B89555'
          }} aria-label="Siguiente" data-id="element-324">
              <ChevronRight className="w-5 h-5" data-id="element-325" />
            </button>
          </div>

          {/* Name tag */}
          <div className="mt-5 px-5 py-2 rounded-full text-center" style={{
          background: 'rgba(200,169,106,0.12)',
          border: '1px solid rgba(200,169,106,0.3)'
        }} data-id="element-326">
            <p className="font-serif font-bold text-sm" style={{
            color: '#1C1C1C'
          }} data-id="element-327">
              {testimonials[current].name}
            </p>
            <p className="text-xs" style={{
            color: '#9A9A9A'
          }} data-id="element-328">
              {testimonials[current].role}
            </p>
          </div>

          {/* Dots */}
          <div className="flex justify-center gap-2 mt-4" data-id="element-329">
            {testimonials.map((_, i) => <button key={i} onClick={() => goTo(i, i > current ? 'right' : 'left')} className="rounded-full transition-all duration-300" style={{
            width: i === current ? '24px' : '8px',
            height: '8px',
            background: i === current ? '#C8A96A' : 'rgba(200,169,106,0.3)'
          }} aria-label={`Ir al testimonio ${i + 1}`} data-id="element-330" />)}
          </div>

          {/* Counter */}
          <p className="text-xs mt-2 font-bold tracking-widest uppercase" style={{
          color: '#9A9A9A'
        }} data-id="element-331">
            {current + 1} / {testimonials.length}
          </p>
        </div>
      </div>
      <div className="gold-divider absolute bottom-0 inset-x-0" data-id="element-332" />
    </section>;
}